<template>
  <div class="dashboard-widget">
    <v-card :elevation="0">
      <v-card-title>
        <span class="widget-title" :class="[titleType]">
          {{ title }}
        </span>
        <!-- temporary without tooltips -->
        <!--        <TooltipIcon-->
        <!--          icon="icon-light-bulb"-->
        <!--          color="grey-darker"-->
        <!--          custom-class="widget-tooltip"-->
        <!--          :custom-style="tooltipStyle"-->
        <!--          :icon-size="24"-->
        <!--        >-->
        <!--          {{ tooltip }}-->
        <!--        </TooltipIcon>-->
      </v-card-title>
      <v-card-text :class="{ 'overflow-hidden': contentOverflow }">
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="!hideDetails">
        <ui-button text @click="actionHandler()">
          {{ $t("message.common.more") }}
        </ui-button>
      </v-card-actions>
      <SectionLoader :status="loading" :opacity="1" />
    </v-card>
  </div>
</template>

<script>
import TooltipIcon from "@/components/ui/TooltipIcon";
import SectionLoader from "@/components/Loader/SectionLoader";

export default {
  name: "DashboardWidget",
  components: {
    // TooltipIcon,
    SectionLoader
  },
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String
    },
    actionHandler: {
      type: Function,
      default: () => void 0
    },
    titleType: {
      type: String,
      default: "bold",
      validator: prop => ["bold", "thin"].includes(prop)
    },
    loading: {
      type: Boolean,
      default: false
    },
    contentOverflow: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tooltipStyle: {
        position: "absolute",
        top: "24px",
        right: "24px"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.dashboard-widget::v-deep {
  height: 100%;

  .widget-title {
    color: $text;
    @include font-size(16px);
    line-height: 22px;
    margin-right: $spacing * 3;
    word-break: break-word;

    &.bold {
      font-weight: 600;
    }

    &.thin {
      font-weight: 500;
      text-transform: uppercase;
      opacity: 0.5;
    }
  }

  .widget-tooltip {
    opacity: 0.5;
  }

  .v-card {
    border-radius: 25px;
    filter: $shadow-filter;
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-card__title {
      position: absolute;
      padding: $spacing * 4 $spacing * 4 $spacing * 2;
      width: 100%;
    }

    .v-card__text {
      margin-top: $spacing * 11;
      padding: 0 $spacing * 4;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
    }

    .v-card__actions {
      padding: 0 $spacing * 3 $spacing * 2;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
